var camelCase = function(s) {
    return s.replace(/([-_][a-z])/gi, function(match) {
        return match.toUpperCase().replace("-", "").replace("_", "");
    });
};
export default camelCase;
